import { render, staticRenderFns } from "./foot-cpright.vue?vue&type=template&id=77fe47ae&scoped=true&"
import script from "./foot-cpright.vue?vue&type=script&lang=js&"
export * from "./foot-cpright.vue?vue&type=script&lang=js&"
import style0 from "./foot-cpright.vue?vue&type=style&index=0&id=77fe47ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe47ae",
  null
  
)

export default component.exports